export const SET_USER = "SET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
